import React from 'react';
import PropTypes from 'prop-types';
import useIntl from '@afosto/utils-react/intl/useIntl';
import Property from '@afosto/app-components-react/Property';
import formatCurrency from '@afosto/utils/formatCurrency';
import { boolean as booleanFormatter } from '@afosto/app-components-react/DataGrid/formatters';
import translations from './translations';

const Adjustment = ({ adjustment }) => {
  const intl = useIntl();

  return (
    <>
      <Property
        label={intl.formatMessage(translations.properties.description)}
        value={adjustment?.description}
      />

      {!adjustment?.is_percentage && (
        <Property
          label={intl.formatMessage(translations.properties.amount)}
          value={adjustment?.amount && formatCurrency(adjustment.amount / 100)}
        />
      )}

      {adjustment?.is_percentage && (
        <Property
          label={intl.formatMessage(translations.properties.amount)}
          value={adjustment?.amount && `${adjustment.amount}%`}
        />
      )}

      <Property
        label={intl.formatMessage(translations.properties.discount)}
        value={booleanFormatter(adjustment.is_discount)}
      />
    </>
  );
};

Adjustment.propTypes = {
  adjustment: PropTypes.object,
};

Adjustment.defaultProps = {
  adjustment: undefined,
};

export default Adjustment;
